import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { SolutionGrid, SolutionGridLayout, } from '@wix/app-market-collection-widget';
import React from 'react';
import { getSolutionsBiData } from '../../bi/biEvents';
import { Loader, Box } from 'wix-style-react';
import { withExperiments } from '../../component-decorators/with-experiments';
import { fetchNewRecommendedApps, getRecommendationsFromML } from '../../api';
import { biLogger } from '../../bi';
import { v4 as generateUuidV4 } from 'uuid';
var RecommendedApps = /** @class */ (function (_super) {
    __extends(RecommendedApps, _super);
    function RecommendedApps(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isFetching: true, solutions: [] };
        return _this;
    }
    RecommendedApps.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, baseUrl, authorizationHeader, locale, experiments, apps, appIds, appIdsList, solutions, collimp_id;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, baseUrl = _a.baseUrl, authorizationHeader = _a.authorizationHeader, locale = _a.locale, experiments = _a.experiments;
                        collimp_id = generateUuidV4();
                        if (!experiments.enabled('specs.marketplace.useMLInManageAndAppPage')) return [3 /*break*/, 2];
                        return [4 /*yield*/, getRecommendationsFromML(baseUrl, '4', locale, authorizationHeader)];
                    case 1:
                        apps = _b.sent();
                        solutions = apps === null || apps === void 0 ? void 0 : apps.webSolutions.map(function (_a) {
                            var baseInfo = _a.baseInfo;
                            return baseInfo;
                        });
                        appIds = solutions.map(function (webSolution) { return webSolution.id; });
                        appIdsList = appIds === null || appIds === void 0 ? void 0 : appIds.join(',');
                        biLogger.appMarketAppCollectionImpressions({
                            apps_list: appIdsList,
                            collimp_id: collimp_id,
                            number_of_apps: 4,
                            tag_name: 'user-recommendations',
                            tag_type: 'manage_apps',
                            prediction_type: apps === null || apps === void 0 ? void 0 : apps.predictionType
                        })
                            .catch(function (e) { return console.log(e); });
                        solutions = apps === null || apps === void 0 ? void 0 : apps.webSolutions.map(function (_a) {
                            var baseInfo = _a.baseInfo;
                            return baseInfo;
                        });
                        this.setState({ isFetching: false, solutions: solutions, collimp_id: collimp_id });
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, fetchNewRecommendedApps(baseUrl, authorizationHeader, locale)];
                    case 3:
                        apps = _b.sent();
                        solutions = apps === null || apps === void 0 ? void 0 : apps.webSolutions.map(function (_a) {
                            var baseInfo = _a.baseInfo;
                            return baseInfo;
                        });
                        appIds = solutions.map(function (webSolution) { return webSolution.id; });
                        appIdsList = appIds === null || appIds === void 0 ? void 0 : appIds.join(',');
                        biLogger.appMarketAppCollectionImpressions({
                            apps_list: appIdsList,
                            collimp_id: collimp_id,
                            number_of_apps: 4,
                            tag_name: 'user-recommendations',
                            tag_type: 'manage_apps',
                            prediction_type: 'old_rec'
                        })
                            .catch(function (e) { return console.log(e); });
                        this.setState({ isFetching: false, solutions: solutions, collimp_id: collimp_id });
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    RecommendedApps.prototype.render = function () {
        var _this = this;
        var _a = this.props, origin = _a.origin, msid = _a.msid, locale = _a.locale, editorType = _a.editorType, experiments = _a.experiments;
        var _b = this.state, solutions = _b.solutions, isFetching = _b.isFetching;
        var biData = getSolutionsBiData(solutions, origin, msid, 'recommended_apps', editorType);
        return (React.createElement(React.Fragment, null,
            isFetching && (React.createElement(Box, { align: 'center' },
                React.createElement(Loader, { size: "medium" }))),
            !isFetching && (React.createElement(SolutionGrid, { solutions: solutions, solutionsBiData: biData, layout: SolutionGridLayout.INTEGRATIONS, locale: locale, colSpan: 4, onBoxClick: function (app) { return _this.props.gotoWebSolutionPage(app.slug, 'manage_apps', _this.state.collimp_id, 'manage-apps-user-recommendations'); }, numberOfLines: 1 }))));
    };
    RecommendedApps = __decorate([
        withExperiments
    ], RecommendedApps);
    return RecommendedApps;
}(React.Component));
export { RecommendedApps };
//# sourceMappingURL=recommended-apps.js.map